import Image from 'next/image';
import Link from 'next/link';
import { ArrowRight, Check } from 'lucide-react';
// import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import Button from '../ui/button-old';
import { useState, useEffect } from 'react';
import heroImage from '@/assets/images/hero.png';
import { PricingPlans } from '../billing/pricing-plans';
import { useRouter } from 'next/router';
import FounderImage from '@/assets/images/alex-founder.jpg';
import AlexGivingTEDTalk from '@/assets/images/alex-giving-ted-talk.jpg';
import alex1 from '@/assets/images/my-generator/alex-1.jpeg';
import alex2 from '@/assets/images/my-generator/alex-2.jpg';
import alex4 from '@/assets/images/my-generator/alex-4.jpg';
import aiAlex1 from '@/assets/images/my-generator/ai-alex1.jpg';
import aiAlex2 from '@/assets/images/my-generator/ai-alex6.jpeg';
import aiAlex3 from '@/assets/images/my-generator/ai-alex3.jpg';
import aiAlex4 from '@/assets/images/my-generator/ai-alex4.jpg';
import aiAlex5 from '@/assets/images/my-generator/ai-alex5.jpeg';
import { trackEvent } from '@/data/utils/utils';
import TypesSection from '@/components/home/types-section';

export default function FluxLanding() {
  const router = useRouter();
  const [activeTab, setActiveTab] = useState('subscription');

  const onTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const [currentText, setCurrentText] = useState('Photographer');
  const [isVisible, setIsVisible] = useState(true);
  const textOptions = ['Photographer', 'Designer', 'Artist'];
  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentText((prevText) => {
          const currentIndex = textOptions.indexOf(prevText);
          const nextIndex = (currentIndex + 1) % textOptions.length;
          return textOptions[nextIndex];
        });
        setIsVisible(true);
      }, 500); // Wait for fade out before changing text
    }, 2000); // Change text every 2 seconds (adjust as needed)

    return () => clearInterval(intervalId);
  }, []);
  return (
    <div className="flex w-full flex-1 flex-col items-center">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-12 text-gray-900 dark:text-gray-100 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
        <div className="flex w-full flex-col items-center gap-8 lg:flex-row lg:items-start">
          <div className="flex w-full flex-col space-y-6 lg:w-1/2">
            <h1 className="text-4xl font-bold md:text-5xl lg:text-6xl">
              Your Consistent AI
              <br />
              {/* Have Your Own<br/> */}
              <span className="text-brand dark:text-brand-dark">
                <span
                  className={`rotating-text duration-500 transition-opacity ${
                    isVisible ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  {currentText}
                </span>
              </span>
              {/* <br/>And Save Money */}
              {/* <br/>With Consitent AI */}
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300 md:text-xl">
              The #1 way to train custom AI image models for consistent
              headshots, portraits, products, and brand assets.
            </p>
            <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
              <Link
                href="/my-consistent-ai/train"
                className="w-full sm:w-auto"
                onClick={() =>
                  trackEvent('click_train_model', { location: 'hero_section' })
                }
              >
                <Button className="w-full border border-brand !bg-brand text-white shadow-lg duration-300 transition-all hover:bg-brand/90 hover:shadow-xl sm:w-auto">
                  Train My Model
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <Link
                href="/my-consistent-ai/overview"
                className="w-full sm:w-auto "
                onClick={() =>
                  trackEvent('click_sign_in', { location: 'hero_section' })
                }
              >
                <Button variant="outline" className="w-full sm:w-auto">
                  Sign In
                </Button>
              </Link>
            </div>
            <div className="mt-4 flex items-center justify-center sm:justify-start">
              <div className="flex items-center gap-2">
                <p className="text-base font-bold text-default-400">Flux AI</p>
                <span className="text-default-400">•</span>
                <a
                  href="https://bfl.ai/"
                  target="_blank"
                  className="text-xs text-default-400 underline"
                  rel="noreferrer"
                >
                  Powered by Black Forest Labs
                </a>
              </div>
            </div>
            <div className="flex items-center justify-center space-x-2 text-yellow-400 sm:justify-start">
              <span>★★★★</span>
              <span className="text-sm text-gray-600 dark:text-gray-300">
                Trusted by 1,000+ professionals
              </span>
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <Image
              src={heroImage}
              alt="AI Image Model Examples"
              width={600}
              height={400}
              className="h-full w-full rounded-lg bg-transparent object-cover duration-300 transition-transform hover:scale-105"
            />
          </div>
        </div>

        {/* How It Works section */}
        <div className="mt-12 w-full sm:mt-20">
          <div className="w-full space-y-6 rounded-lg bg-white p-4 shadow-xl dark:bg-dark-100 sm:space-y-8 sm:p-6 md:p-8 lg:p-12">
            <h2 className="text-center text-2xl font-bold sm:text-3xl lg:text-4xl">
              How It Works
            </h2>
            <Tabs
              defaultValue="Person"
              className="w-full space-y-4 sm:space-y-6 md:space-y-8 lg:space-y-10"
            >
              <TabsList className="mx-auto flex h-fit w-fit flex-wrap justify-center gap-1.5 rounded-xl border border-brand bg-gray-100 p-1 sm:gap-2 sm:rounded-2xl sm:p-2">
                <TabsTrigger
                  value="Person"
                  className="px-2 py-1 text-xs data-[state=active]:bg-brand data-[state=active]:text-white sm:px-3 sm:py-1.5 sm:text-sm"
                >
                  Person
                </TabsTrigger>
                <TabsTrigger
                  value="Product"
                  className="px-2 py-1 text-xs data-[state=active]:bg-brand data-[state=active]:text-white sm:px-3 sm:py-1.5 sm:text-sm"
                >
                  Product
                </TabsTrigger>
                <TabsTrigger
                  value="Style"
                  className="px-2 py-1 text-xs data-[state=active]:bg-brand data-[state=active]:text-white sm:px-3 sm:py-1.5 sm:text-sm"
                >
                  Style
                </TabsTrigger>
                <TabsTrigger
                  value="Fashion"
                  className="px-2 py-1 text-xs data-[state=active]:bg-brand data-[state=active]:text-white sm:px-3 sm:py-1.5 sm:text-sm"
                >
                  Fashion
                </TabsTrigger>
              </TabsList>

              <TabsContent value="Person" className="mt-2 w-full">
                <HowItWorksSteps
                  steps={[
                    {
                      title: 'Upload sample images',
                      description: (
                        <span className="text-xs sm:text-sm md:text-base">
                          Upload 4+ high-quality images: front facing, 1 subject
                          in frame
                        </span>
                      ),
                      imageSrcs: [alex1, alex2, FounderImage, alex4],
                      imageAlts: [
                        'Sample 1',
                        'Sample 2',
                        'Sample 3',
                        'Sample 4',
                      ],
                      className: 'grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4',
                    },
                    {
                      title: 'AI Model Training',
                      description: (
                        <span className="text-xs sm:text-sm md:text-base">
                          max. 5 minutes
                        </span>
                      ),
                      imageSrcs: [
                        '/placeholder.svg',
                        '/placeholder.svg',
                        '/placeholder.svg',
                        '/placeholder.svg',
                      ],
                      imageAlts: [
                        'Processing 1',
                        'Processing 2',
                        'Processing 3',
                        'Processing 4',
                      ],
                      className: 'grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4',
                    },
                    {
                      title: 'Generate stunning, consistent images',
                      description: (
                        <span className="text-xs sm:text-sm md:text-base">
                          Once your model is trained, generate images of your
                          subject from text prompts
                        </span>
                      ),
                      imageSrcs: [
                        AlexGivingTEDTalk,
                        aiAlex2,
                        aiAlex5,
                        aiAlex4,
                        aiAlex3,
                        aiAlex1,
                      ],
                      imageAlts: [
                        'Result 1',
                        'Result 2',
                        'Result 3',
                        'Result 4',
                        'Result 5',
                        'Result 6',
                      ],
                      className:
                        'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-4',
                    },
                  ]}
                  className="space-y-6 sm:space-y-8 md:space-y-10"
                  stepClassName="space-y-3 sm:space-y-4"
                  titleClassName="text-lg sm:text-xl md:text-2xl font-semibold"
                  descriptionClassName="text-gray-600 dark:text-gray-400"
                  imagesClassName="grid mt-3 sm:mt-4"
                />
              </TabsContent>

              <TabsContent value="Product" className="mt-2 w-full">
                <HowItWorksSteps
                  steps={[
                    {
                      title: 'Upload product images',
                      description:
                        'Upload 4+ high-quality images of your product from different angles',
                      imageSrcs: [
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-input-example2.png',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-input-example1.png',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-input-example5.png',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-input-example7.png',
                      ],
                      imageAlts: ['AI Product shot samples'],
                    },
                    {
                      title: 'AI Model Training',
                      description: (
                        <span className="text-xs sm:text-sm md:text-base">
                          max. 5 minutes
                        </span>
                      ),
                      imageSrcs: ['/placeholder.svg'],
                      imageAlts: ['AI Product shot loading'],
                    },
                    {
                      title: 'Create diverse product images',
                      description:
                        'Generate various product shots with different backgrounds and styles',
                      imageSrcs: [
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-output-example2.png',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-output-example1.png',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-output-example5.png',
                        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-output-example4.png',
                      ],
                      imageAlts: ['AI Product shot results'],
                    },
                  ]}
                />
              </TabsContent>

              <TabsContent value="Style" className="mt-2 w-full">
                <HowItWorksSteps
                  steps={[
                    {
                      title: 'Upload style reference images',
                      description:
                        'Upload 4+ images that represent your desired style or brand',
                      imageSrcs: [
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Style/product-output-example1.jpeg',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Style/product-output-example2.jpeg',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Style/product-output-example3.jpeg',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Style/product-output-example4.jpeg',
                      ],
                      imageAlts: ['AI Style samples'],
                    },
                    {
                      title: 'AI Model Training',
                      description: (
                        <span className="text-xs sm:text-sm md:text-base">
                          max. 5 minutes
                        </span>
                      ),
                      imageSrcs: ['/placeholder.svg'],
                      imageAlts: ['AI Style loading'],
                    },
                    {
                      title: 'Generate styled images',
                      description:
                        'Create images in your learned style for various subjects or products',
                      imageSrcs: [
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/ink-art-1.png',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/ink-art-2.png',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/ink-art-3.png',
                      ],
                      imageAlts: ['AI Style results'],
                    },
                  ]}
                />
              </TabsContent>

              <TabsContent value="Fashion" className="mt-2 w-full">
                <HowItWorksSteps
                  steps={[
                    {
                      title: 'Upload Fashion photos',
                      description:
                        'Upload 4+ clear, high-quality images of your Fashion product',
                      imageSrcs: [
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-input-example1.jpeg',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-input-example2.jpeg',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-input-example3.jpeg',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-input-example4.jpeg',
                      ],
                      imageAlts: ['AI Fashion portrait samples'],
                    },
                    {
                      title: 'AI Model Training',
                      description: (
                        <span className="text-xs sm:text-sm md:text-base">
                          max. 5 minutes
                        </span>
                      ),
                      imageSrcs: ['/placeholder.svg'],
                      imageAlts: ['AI Fashion portrait loading'],
                    },
                    {
                      title: 'Generate Fashion portraits',
                      description:
                        'Create various portraits and scenes featuring your Fashion',
                      imageSrcs: [
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-output-example1.jpeg',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-output-example2.jpeg',
                        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-output-example3.jpeg',
                      ],
                      imageAlts: ['AI Fashion portrait results'],
                    },
                  ]}
                />
              </TabsContent>
            </Tabs>
          </div>
        </div>

        {/* Featured Models section */}
        <div className="mt-20 w-full space-y-12">
          <div className="text-center">
            <h2 className="text-3xl font-bold sm:text-4xl">
              Models From The Community
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-gray-600 dark:text-gray-400">
              Explore our collection of powerful AI Models for creating stunning
              images
            </p>
          </div>
          <TypesSection label="" />
        </div>

        {/* Pricing section */}
        <div className="mt-20 w-full space-y-12">
          <h2 className="text-center text-3xl font-bold sm:text-4xl">
            Pricing
          </h2>
          <PricingPlans onTabChange={onTabChange} activeTab={activeTab} />
          <div className="flex justify-center">
            <Link
              href="/pricing"
              className="text-lg font-medium text-brand transition-colors hover:text-brand/80"
              onClick={() =>
                trackEvent('click_view_all_pricing', {
                  location: 'landing_page',
                })
              }
            >
              View all pricing details →
            </Link>
          </div>
        </div>

        {/* FAQ section */}
        <div className="mt-20 w-full">
          <div className="w-full rounded-lg bg-white p-6 shadow-xl dark:bg-dark-100 sm:p-8 md:p-12">
            <h2 className="mb-8 text-center text-2xl font-bold sm:text-3xl">
              Frequently Asked Questions
            </h2>
            <Accordion
              defaultValue="item-1"
              type="single"
              collapsible
              className="mx-auto w-full max-w-[768px]"
            >
              <AccordionItem value="item-1">
                <AccordionTrigger className="text-left text-lg sm:text-xl">
                  What types of AI image models can I train?
                </AccordionTrigger>
                <AccordionContent className="text-base font-light text-default-500 sm:text-lg">
                  Our platform allows you to train high-quality AI image models
                  for various purposes, including headshots, portraits,
                  products, and brand assets. We use the highest quality Flux AI
                  image model for training.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger className="text-left text-lg sm:text-xl">
                  How long does it take to train a custom AI model?
                </AccordionTrigger>
                <AccordionContent className="text-base font-light text-default-500 sm:text-lg">
                  Training custom AI image models takes approximately 5 minutes.
                  Once the model is trained, you can generate consistent images
                  in less than 10 seconds.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger className="text-left text-lg sm:text-xl">
                  How many images do I need to train a custom model?
                </AccordionTrigger>
                <AccordionContent className="text-base font-light text-default-500 sm:text-lg">
                  You need at least 4 high-quality images to train a custom
                  model. However, for best results, we recommend using 10-20
                  high-quality images that follow our guidelines.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger className="text-left text-lg sm:text-xl">
                  Can I use the generated images commercially?
                </AccordionTrigger>
                <AccordionContent className="text-base font-light text-default-500 sm:text-lg">
                  Yes, our Starter, Creator, and Professional plans offer full,
                  commercial ownership of the images you generate. This means
                  you can use the AI-generated images for your business needs
                  without any restrictions.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-5">
                <AccordionTrigger className="text-left text-lg sm:text-xl">
                  Do you offer support for using the platform?
                </AccordionTrigger>
                <AccordionContent className="text-base font-light text-default-500 sm:text-lg">
                  Yes, we provide comprehensive support to help you succeed with
                  our platform. Our team offers guidance and assistance to
                  ensure you get the most out of our services. For Enterprise
                  clients, we offer white glove asset generation and access to
                  our team of world-class AI experts.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}

function HowItWorksSteps({
  steps,
}: {
  steps: Array<{
    title: string;
    description: React.ReactNode;
    imageSrcs: any[];
    imageAlts: string[];
  }>;
}) {
  return (
    <div className="flex w-full flex-col items-center justify-between gap-6 lg:flex-row lg:items-start lg:gap-4">
      {/* Step 1 */}
      <div className="flex w-full flex-1 flex-col items-center space-y-4">
        <div className="flex items-center justify-center space-x-3">
          <div className="flex aspect-square h-6 w-6 items-center justify-center rounded-full bg-brand text-lg font-bold text-white sm:h-8 sm:w-8 sm:text-2xl">
            1
          </div>
          <h3 className="text-base font-semibold sm:text-lg lg:text-xl">
            {steps[0].title}
          </h3>
        </div>
        <p className="text-center text-xs text-default-500 sm:text-sm">
          {steps[0].description}
        </p>
        <div className="mx-auto grid max-w-[400px] grid-cols-2 gap-2 sm:grid-cols-2 lg:grid-cols-2">
          {steps[0].imageSrcs.map((src, index) => (
            <Image
              key={index}
              src={src}
              alt={steps[0].imageAlts[index]}
              width={120}
              height={120}
              className="h-[120px] w-full rounded-lg object-cover sm:h-[150px] lg:h-[180px]"
            />
          ))}
        </div>
      </div>

      {/* Arrow - Different for mobile and desktop */}
      <div className="flex flex-shrink-0 flex-row items-center justify-center gap-3 py-4 lg:flex-col lg:px-4">
        <div className="relative h-12 w-12 flex-shrink-0 sm:h-16 sm:w-16 lg:h-24 lg:w-24">
          {/* Mobile Arrow (down) */}
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 96 96"
            fill="none"
            className="text-gray-900 dark:text-white lg:hidden"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M48 10C48 10 38 30 48 48C58 66 48 86 48 86M48 86L38 76M48 86L58 76"
              stroke="currentColor"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {/* Desktop Arrow (right) */}
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 96 96"
            fill="none"
            className="hidden text-gray-900 dark:text-white lg:block"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 48C10 48 30 38 48 48C66 58 86 48 86 48M86 48L76 38M86 48L76 58"
              stroke="currentColor"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="flex-1 text-center text-xs font-medium text-brand sm:text-sm lg:mt-2 lg:flex-initial lg:text-lg">
          {steps[1].title}
        </div>
        <div className="text-center text-xs text-default-500 sm:text-sm">
          {steps[1].description}
        </div>
      </div>

      {/* Step 3 */}
      <div className="flex w-full flex-1 flex-col items-center space-y-4">
        <div className="flex items-center justify-center space-x-3">
          <div className="flex aspect-square h-6 w-6 items-center justify-center rounded-full bg-brand text-lg font-bold text-white sm:h-8 sm:w-8 sm:text-2xl">
            2
          </div>
          <h3 className="text-base font-semibold sm:text-lg lg:text-xl">
            {steps[2].title}
          </h3>
        </div>
        <p className="text-center text-xs text-default-500 sm:text-sm">
          {steps[2].description}
        </p>
        <div className="mx-auto grid max-w-[500px] grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-3">
          {steps[2].imageSrcs.map((src, index) => (
            <Image
              key={index}
              src={src}
              alt={steps[2].imageAlts[index]}
              width={150}
              height={150}
              className="h-[120px] w-full rounded-lg object-cover sm:h-[150px] lg:h-[180px]"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
